import { PropsWithChildren } from 'react';

import Notification from '@oncore/ui/Notification';
import OncoreNotification, {
  OncoreNotificationProps,
} from '@oncore/ui/shared/OncoreNotification';

export type AppNotificationProps = PropsWithChildren<OncoreNotificationProps>;

const AppNotification = (props: AppNotificationProps) => {
  const {
    children,
    queryClient,
  } = props;

  return (
    <Notification position="bottom-right">
      {children}
      <OncoreNotification queryClient={queryClient}/>
    </Notification>
  );
};

export default AppNotification;

